import type { FaireProductEntity } from "../../entity_types/product";

export const p_rwqfqcxuxz: FaireProductEntity = {
  token: "p_rwqfqcxuxz",
  type: "product",
  name: "White Cubic Zirconia 18K Gold Plated SS Adjustable Ring -FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/6f7e13d0d3d8ed8cc0d198f706e9dc1445c54653fcb3a73dec1c2b48ae1b5d8a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2d554fa4fe8f6c886e3d622baf3f650df8f3e4310061bb3ad204e4ff683d1545.jpeg",
    "https://cdn.faire.com/fastly/8f3669ec68e7c8a373ce4ce2d8f417ee4de5070d95f8e10415e102c5a6f888aa.jpeg",
    "https://cdn.faire.com/fastly/c605e18b8e2d4be4b3ce14e5fd4db8a1e6407080b0869e3862d834b069bb614d.jpeg",
    "https://cdn.faire.com/fastly/326f79ff4e5f66baf4fc26ebe92063e21300ba928372e36afc035fabad831329.jpeg",
    "https://cdn.faire.com/fastly/57a0752664e15a8b6b693f3a7b1d9cc80779a5ce5efeb86bf997e2786d5dc6d8.jpeg",
  ],
  priceDollars: 7.41,
  description:
    "\nType: Ring\nMaterial : Stainless steel ,Cubic zirconia,18K gold plated\nSize : Cubic zirconia - 9mm , Adjustable\nProcess: Vacuum electroplating and manual polishing\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n\n\n★Perfect jewelry gifts\n",
  tags: [],
  msrpDollars: 20.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:53.974Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
